module.exports = __webpack_public_path__ + "static/zoe-web-arm@2x-1e86f42d8339ba90ce0fb06bb2b65309.jpg";